import { memo, type ReactNode } from "react";

/**
 * SectionKicker — the numbered eyebrow a marketing section opens with:
 * "NN · Title" set left, a note set right, the spectrum thread ruled above.
 *
 * Nine sections hand-wrote this row under eight block prefixes. The prefixes
 * carried nothing of their own — the numeral spans had no rules at all, and
 * the notes were eight copies of one muted colour — so the row keeps only the
 * shared name and the per-section classes are gone from home.css.
 *
 * Two sections deliberately keep their own markup. TheProblem measures its row
 * to position a sliding tick, so the row element itself is a ref target and
 * carries an extra tick child. FaqSection's row spans a two-column grid on its
 * own rule. Neither is this shape.
 */
export const SectionKicker = memo(function SectionKicker({
  numeral,
  label,
  note,
}: {
  numeral: string;
  label: ReactNode;
  note: ReactNode;
}) {
  return (
    <div className="dw-home__kicker-row dw-text-caption dw-tabular-nums" data-tone="foreground" data-component="SectionKicker" data-location="src/components/home/section-kicker.tsx">
      <span>
        {numeral} · {label}
      </span>
      <span data-tone="muted">{note}</span>
    </div>
  );
});
